import { render, staticRenderFns } from "./payType.vue?vue&type=template&id=1d8f794b&scoped=true"
import script from "./payType.vue?vue&type=script&lang=js"
export * from "./payType.vue?vue&type=script&lang=js"
import style0 from "./payType.vue?vue&type=style&index=0&id=1d8f794b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f794b",
  null
  
)

export default component.exports